<template>
  <div class="app-main-inner" type="primary">
    <div class="app-main-page" style="height: calc(100vh - 130px)">
      <div class="app-main-inner-row">
        <div class="triggers">
          <el-button size="mini" type="primary" @click="toQuery">{{ $t('Information.Search') }}</el-button>
          <el-button size="mini" type="primary" @click="toAddSeaPortRequirement">{{ $t('Information.Add') }}</el-button>
          <el-button size="mini" type="primary" @click="toUpdateSeaPortRequirement">{{ $t('Information.Edit') }}</el-button>
          <el-button size="mini" type="danger" @click="toBatchDelSeaPortRequirement">{{ $t('Information.Delete') }}</el-button>
          <cargo-grid-state-btn :grid-params="gridParams" config-module="101340" />
        </div>
      </div>
      <div class="app-main-inner-row">
        <el-form :inline="true" label-width="100px" label-position="left" @submit.native.prevent>
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('Information.PortOfLoadingPOL')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Seaport"
                callback-method-type="value"
                :default-value="searchConditions.loadingPortCode"
                style="width:205px;"
                :callback-params="{key:'loadingPortCode'}"
                @parentCallBack="getValueSearchFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('Information.PortOfDischargePOD')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Seaport"
                callback-method-type="value"
                :default-value="searchConditions.dischargingPortCode"
                style="width:205px;"
                :callback-params="{key:'dischargingPortCode'}"
                @parentCallBack="getValueSearchFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('Information.PlaceOfDelivery')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Seaport"
                callback-method-type="value"
                :default-value="searchConditions.destinationPortCode"
                style="width:205px;"
                :callback-params="{key:'destinationPortCode'}"
                @parentCallBack="getValueSearchFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('Information.TransportationTerms')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                callback-method-type="value"
                :default-value="searchConditions.freightTerm"
                style="width:205px;"
                :callback-params="{key:'freightTerm'}"
                @parentCallBack="getValueSearchFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('Information.CargoType')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_CargoType"
                callback-method-type="value"
                :default-value="searchConditions.cargoType"
                style="width:205px;"
                :callback-params="{key:'cargoType'}"
                @parentCallBack="getValueSearchFromChild"
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="app-main-inner-row">
        <el-form :inline="true" label-width="100px" label-position="left" @submit.native.prevent>
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('Information.ShippingCompany')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{seaCmp:true}"
                callback-method-type="value"
                :default-value="searchConditions.carrierId == 0 ? '': searchConditions.carrierId"
                style="width:205px;"
                :callback-params="{key:'carrierId'}"
                @parentCallBack="getValueSearchFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('Information.DestinationPortAgent')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                callback-method-type="value"
                :default-value="searchConditions.destinationAgent == 0 ? '': searchConditions.destinationAgent"
                style="width:205px;"
                :method-params="{overseaAgent:true}"
                :callback-params="{key:'destinationAgent'}"
                @parentCallBack="getValueSearchFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('Information.ShippingRoute')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Region"
                :callback-params="{key:'region'}"
                callback-method-type="value"
                :default-value="searchConditions.region"
                style="width:205px;"
                @parentCallBack="getValueSearchFromChild"
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="app-main-inner-row row-grid">
        <cargo-ag-grid
          config-module="101340"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div class="app-main-inner-row row-pagination">
        <cargo-pagination
          v-show="searchConditions.total>0"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchSeaPortRequirement"
        />
      </div>
    </div>
    <el-dialog
      v-if="isShowingSeaportRequirementForm"
      v-el-drag-dialog
      custom-class=""
      :visible.sync="isShowingSeaportRequirementForm"
      :title="formTitle"
      width="1000px"
      :close-on-click-modal="false"
      @close="cancel"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form :model="seaPortRequirement" inline label-width="110px" label-position="left">
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('Information.DisplayRules')">
              <template>
                <el-checkbox v-model="seaPortRequirement.mbl">MBL</el-checkbox>
                <el-checkbox v-model="seaPortRequirement.hbl">HBL</el-checkbox>
              </template>
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper" style="padding-top: 10px;">
            <el-form-item :label="$t('Information.PortOfLoadingPOL')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Seaport"
                callback-method-type="value"
                :default-multiple-value="seaPortRequirement.loadingPortCodeArray"
                style="width:300px;"
                :callback-params="{}"
                multiple
                @parentCallBack="item=>seaPortRequirement.loadingPortCodeArray=item.value"
              />
            </el-form-item>
            <el-form-item :label="$t('Information.PortOfDischargePOD')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Seaport"
                callback-method-type="value"
                :default-multiple-value="seaPortRequirement.dischargingPortCodeArray"
                style="width:300px;"
                :callback-params="{}"
                multiple
                @parentCallBack="item=>seaPortRequirement.dischargingPortCodeArray=item.value"
              />
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper" style="padding-top: 10px;">
            <el-form-item :label="$t('Information.PlaceOfDelivery')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Seaport"
                callback-method-type="value"
                :default-multiple-value="seaPortRequirement.destinationPortCodeArray"
                style="width:300px;"
                :callback-params="{}"
                multiple
                @parentCallBack="item=>seaPortRequirement.destinationPortCodeArray=item.value"
              />
            </el-form-item>
            <el-form-item :label="$t('Information.ShippingRoute')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Region"
                :default-multiple-value="seaPortRequirement.regionCodeArray"
                style="width:300px;"
                :callback-params="{}"
                multiple
                @parentCallBack="item=>seaPortRequirement.regionCodeArray=item.value"
              />
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper" style="padding-top: 10px;">
            <el-form-item :label="$t('Information.ShippingCompany')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{seaCmp:true}"
                callback-method-type="value"
                :default-value="seaPortRequirement.carrierId == 0 ? '': seaPortRequirement.carrierId"
                style="width:300px;"
                :callback-params="{key:'carrierId'}"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('Information.DestinationPortAgent')">
              <cargo-advance-select
                :key="1"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                callback-method-type="value"
                :default-value="seaPortRequirement.destinationAgent == 0 ? '': seaPortRequirement.destinationAgent"
                style="width:300px;"
                :method-params="{overseaAgent:true}"
                :callback-params="{key:'destinationAgent'}"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper" style="padding-top: 10px;">
            <el-form-item :label="$t('Information.TransportationTerms')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                callback-method-type="value"
                :default-value="seaPortRequirement.freightTerm"
                style="width:300px;"
                :callback-params="{key:'freightTerm'}"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('Information.CargoType')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_CargoType"
                callback-method-type="value"
                :default-value="seaPortRequirement.cargoType"
                style="width:300px;"
                :callback-params="{key:'cargoType'}"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper" style="padding-top: 10px;">
            <el-form-item :label="$t('Information.OperationalRequirements')">
              <el-input
                v-model="seaPortRequirement.operationRequirements"
                type="textarea"
                :rows="5"
                :placeholder="$t('Information.PleaseEnterTheContent')"
                style="width: 730px"
              />
            </el-form-item>
          </div>
          <div v-show="showCloudFile" class="el-form-item-wrapper" style="padding-top: 10px;">
            <el-form-item :label="$t('Information.AttachmentDescription')">
              <svg-icon icon-class="yibiao-tijiao" @click="appendixDescription" />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="submitSeaPortRequirement">{{ $t('Information.Confirm') }}</el-button>
        <el-button size="mini" @click="isShowingSeaportRequirementForm = false">{{ $t('Information.Cancel') }}</el-button>
      </div>
    </el-dialog>
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      :show-all="cloudFile.showAll"
      @uploadDone="onUploadDone"
    />
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getToken } from '@/utils/auth'
import {
  querySeaPortRequirementList,
  addSeaPortRequirement,
  updateSeaPortRequirement,
  batchDelSeaPortRequirement
} from '@/api/seaportRequirement'
import { getGridSelectedIds, getGridSelected } from '@/utils/agGrid'
import { DocumentManage } from '@/utils/commonUtil'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'SeaPortRequirement',
  components: { cargoAdvanceSelect, cargoCloudFileUpload },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      fullscreenLoading: null,
      currentSessionId: getToken(),
      isShowingSeaportRequirementForm: false,
      formTitle: '',
      searchConditions: {
        loadingPortCode: '',
        dischargingPortCode: '',
        destinationPortCode: '',
        region: '',
        carrierId: 0,
        destinationAgent: 0,
        freightTerm: '',
        cargoType: '',
        mbl: false,
        hbl: false,
        total: 0,
        pageSize: 10,
        pageNum: 1
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [
        {
          headerName: '', checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Information.PortOfLoadingPOL'),
          field: 'loadingPortEnglishName',
          width: 250,
          cellRendererFramework: 'CargoGridShowBigContent'
        },
        {
          headerName: this.$t('Information.PortOfDischargePOD'),
          field: 'dischargingPortEnglishName',
          width: 250,
          cellRendererFramework: 'CargoGridShowBigContent'
        },
        {
          headerName: this.$t('Information.PlaceOfDelivery'),
          field: 'destinationPortEnglishName',
          width: 250,
          cellRendererFramework: 'CargoGridShowBigContent'
        },
        {
          headerName: this.$t('Information.ShippingCompany'),
          field: 'carrierChineseName',
          width: 250,
          cellRendererFramework: 'CargoGridShowBigContent'
        },
        {
          headerName: this.$t('Information.ShippingRoute'),
          field: 'regionEnglishName',
          width: 300,
          cellRendererFramework: 'CargoGridShowBigContent'
        },
        {
          headerName: this.$t('Information.TransportationTerms'),
          field: 'freightTermName',
          width: 150,
          cellRendererFramework: 'CargoGridShowBigContent'
        },
        {
          headerName: this.$t('Information.CargoType'),
          field: 'cargoTypeChineseName',
          width: 150,
          cellRendererFramework: 'CargoGridShowBigContent'
        },
        {
          headerName: this.$t('Information.DestinationPortAgent'),
          field: 'destinationAgentChineseName',
          width: 250,
          cellRendererFramework: 'CargoGridShowBigContent'
        },
        {
          headerName: this.$t('Information.OperationalRequirements'),
          field: 'operationRequirements',
          width: 300,
          cellRendererFramework: 'CargoGridShowBigContent'
        },
        {
          headerName: this.$t('Information.WhetherToUseForMBL'),
          width: 150,
          cellRenderer: params => {
            const iconName = !params.data.mbl ? 'grid-icon-enabled' : 'grid-icon-disabled'
            const color = params.data.mbl ? '#67c23a' : '#e6a23c'
            return `<svg class="svg-icon" fill="${color}" aria-hidden="true" style="height:1.1em;width:1.1em;">
                <use xlink:href="#icon-${iconName}"></use>
              </svg>`
          }
        },
        {
          headerName: this.$t('Information.WhetherToUseForHBL'),
          width: 150,
          cellRenderer: params => {
            const iconName = !params.data.hbl ? 'grid-icon-enabled' : 'grid-icon-disabled'
            const color = params.data.hbl ? '#67c23a' : '#e6a23c'
            return `<svg class="svg-icon" fill="${color}" aria-hidden="true" style="height:1.1em;width:1.1em;">
                <use xlink:href="#icon-${iconName}"></use>
              </svg>`
          }
        },
        {
          headerName: this.$t('Information.AttachmentDescription'),
          field: '',
          width: 150,
          cellRenderer: params => {
            const uuid = params.data.uuid
            return `<span onclick="${this.documentManage.getPath('toShowFile')}('${uuid}')" style="color:#46a6ff">查看附件</span>`
          }
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      initSeaPortRequirement: {
        uuid: '',
        tenantId: 0,
        version: 0,
        createdBy: 0,
        modifiedBy: 0,
        dateModified: new Date(),
        dateCreated: new Date(),
        loadingPortCodes: '',
        dischargingPortCodes: '',
        destinationPortCodes: '',
        regions: '',
        carrierId: 0,
        destinationAgent: 0,
        freightTerm: '',
        cargoType: '',
        mbl: false,
        hbl: false,
        operationRequirements: '',
        loadingPortCodeArray: [],
        dischargingPortCodeArray: [],
        destinationPortCodeArray: [],
        regionCodeArray: []
      },
      seaPortRequirement: {
        uuid: '',
        tenantId: 0,
        version: 0,
        createdBy: 0,
        modifiedBy: 0,
        dateModified: '',
        dateCreated: '',
        loadingPortCodes: '',
        dischargingPortCodes: '',
        destinationPortCodes: '',
        regions: '',
        carrierId: 0,
        destinationAgent: 0,
        freightTerm: '',
        cargoType: '',
        mbl: false,
        hbl: false,
        operationRequirements: '',
        loadingPortCodeArray: [],
        dischargingPortCodeArray: [],
        destinationPortCodeArray: [],
        regionCodeArray: []
      },
      documentManage: new DocumentManage(),
      cloudFile: {
        visible: false,
        job: {
          uuid: ''
        },
        showAll: false,
        lob: 'OTHER'
      },
      showCloudFile: false
    }
  },
  computed: {
    url() {
      return URL
    }
  },
  beforeMount() {
    this.fetchSeaPortRequirement()
  },
  created() {
    this.documentManage.set('toShowFile', this.toShow)
  },
  methods: {
    toShow(uuid) {
      this.cloudFile.showAll = true
      this.cloudFile.job.uuid = uuid
      this.cloudFile.visible = true
    },
    // 查询
    toQuery() {
      this.searchConditions.pageNum = 1
      this.fetchSeaPortRequirement()
    },
    getValueSearchFromChild(obj) {
      this.searchConditions[obj.key] = obj.value
    },
    getValueFromChild(obj) {
      this.seaPortRequirement[obj.key] = obj.value
    },
    // 新增
    toAddSeaPortRequirement() {
      this.showCloudFile = false
      this.seaPortRequirement = { ...this.initSeaPortRequirement }
      this.isShowingSeaportRequirementForm = true
      this.formTitle = '添加港口要求（海港）'
    },
    // 编辑
    toUpdateSeaPortRequirement() {
      const self = this
      const chooseRows = getGridSelected(self.gridOptions)
      if (chooseRows.length !== 1) {
        self.$message.error('请选择一条记录进行编辑')
        return
      }
      const seaPortRequirement = { ...chooseRows[0] }
      self.showCloudFile = true
      // 起运港
      if (seaPortRequirement.loadingPortCodes) {
        seaPortRequirement.loadingPortCodeArray = seaPortRequirement.loadingPortCodes.split(',')
      } else {
        seaPortRequirement.loadingPortCodeArray = []
      }
      // 卸货港
      if (seaPortRequirement.dischargingPortCodes) {
        seaPortRequirement.dischargingPortCodeArray = seaPortRequirement.dischargingPortCodes.split(',')
      } else {
        seaPortRequirement.dischargingPortCodeArray = []
      }
      // 交货地
      if (seaPortRequirement.destinationPortCodes) {
        seaPortRequirement.destinationPortCodeArray = seaPortRequirement.destinationPortCodes.split(',')
      } else {
        seaPortRequirement.destinationPortCodeArray = []
      }
      // 航线
      if (seaPortRequirement.regions) {
        seaPortRequirement.regionCodeArray = seaPortRequirement.regions.split(',')
      } else {
        seaPortRequirement.regionCodeArray = []
      }
      self.seaPortRequirement = { ...seaPortRequirement }
      this.isShowingSeaportRequirementForm = true
      this.formTitle = this.$t('Information.EditPortRequirementsseaPort')
    },
    // 删除
    toBatchDelSeaPortRequirement() {
      const self = this
      const chooseRows = getGridSelected(self.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.error(this.$t('Information.PleaseARecordForDeletion'))
        return
      }
      getGridSelectedIds(self.gridOptions, 'uuid').then(ids => {
        return this.$confirm(this.$t('Information.WhetherDeleteTheSelectedRecords'), this.$t('Information.Notice'), {
          confirmButtonText: this.$t('Information.Confirm'),
          cancelButtonText: this.$t('Information.Cancel'),
          type: 'warning'
        }).then(() => {
          return batchDelSeaPortRequirement(ids)
        }).catch(() => {
          return Promise.reject(this.$t('Information.DeletionCancelled'))
        })
      }).then(res => {
        if (res.ok) {
          this.$message({
            type: 'success',
            message: this.$t('Information.SuccessfullyDeleted')
          })
        } else {
          this.$message({
            type: 'info',
            message: this.$t('Information.DeletionFailed')
          })
        }
        self.fetchSeaPortRequirement()
      }).catch(() => {
      })
    },
    // 新增或者编辑确定按钮事件
    submitSeaPortRequirement() {
      const seaPortRequirement = this.seaPortRequirement
      if (!seaPortRequirement.mbl && !seaPortRequirement.hbl) {
        this.$message.warning(this.$t('Information.DisplayRulesAreRequired'))
        return
      }
      if (seaPortRequirement.operationRequirements === '' || seaPortRequirement.operationRequirements === null || seaPortRequirement.operationRequirements === 'undified') {
        this.$message.warning(this.$t('Information.OperationalRequirementsAreRequired'))
        return
      }

      if (seaPortRequirement.loadingPortCodeArray.length > 0) {
        seaPortRequirement.loadingPortCodes = seaPortRequirement.loadingPortCodeArray.reduce((a, b) => a + ',' + b)
      } else {
        seaPortRequirement.loadingPortCodes = ''
      }

      if (seaPortRequirement.dischargingPortCodeArray.length > 0) {
        seaPortRequirement.dischargingPortCodes = seaPortRequirement.dischargingPortCodeArray.reduce((a, b) => a + ',' + b)
      } else {
        seaPortRequirement.dischargingPortCodes = ''
      }

      if (seaPortRequirement.destinationPortCodeArray.length > 0) {
        seaPortRequirement.destinationPortCodes = seaPortRequirement.destinationPortCodeArray.reduce((a, b) => a + ',' + b)
      } else {
        seaPortRequirement.destinationPortCodes = ''
      }

      if (seaPortRequirement.regionCodeArray.length > 0) {
        seaPortRequirement.regions = seaPortRequirement.regionCodeArray.reduce((a, b) => a + ',' + b)
      } else {
        seaPortRequirement.regions = ''
      }

      if (seaPortRequirement.uuid === '' || seaPortRequirement.uuid === null || seaPortRequirement.uuid === 'undified') {
        return addSeaPortRequirement(this.seaPortRequirement).then(res => {
          this.isShowingSeaportRequirementForm = false
          this.seaPortRequirement = { ...this.initSeaPortRequirement }
          this.$message({ message: this.$t('Information.SuccessfullyAddedPortRequirements'), type: 'success' })
          this.fetchSeaPortRequirement()
        })
      } else {
        return updateSeaPortRequirement(seaPortRequirement).then(res => {
          this.isShowingSeaportRequirementForm = false
          this.seaPortRequirement = { ...this.initSeaPortRequirement }
          this.$message({ message: this.$t('Information.SuccessfullyModifiedPortRequirements'), type: 'success' })
          this.fetchSeaPortRequirement()
        })
      }
    },
    fetchSeaPortRequirement() {
      this.fullscreenLoading = getLoading()
      querySeaPortRequirementList(this.searchConditions).then(res => {
        this.searchConditions.total = Number(res.data.total)
        this.rowData = res.data.list
        this.fullscreenLoading.close()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    onUploadDone() {

    },
    // 附件说明
    appendixDescription() {
      this.cloudFile.job.uuid = this.seaPortRequirement.uuid
      this.cloudFile.showAll = true
      this.cloudFile.visible = true
    },
    cancel() {
      this.seaPortRequirement = { ...this.initSeaPortRequirement }
    }
  }
}
</script>

<style scoped>

</style>
